import { type Routes } from '@angular/router';
import { MainLayout } from './layout/main-layout/main-layout';
import { FooterOnlyLayout } from './layout/footer-only-layout/footer-only-layout';
import { provideFeatureTranslations } from './core/i18n/provide-feature-translations';
import { featureTranslationResolver } from './core/i18n/translation-resolver';
import { langMatcher } from './core/guards/lang-matcher';
import { AuthGuard } from './core/guards/authGuard';
import { LoginGuard } from './core/guards/loginGuard';
import { roleGuard } from './core/guards/role-guard';
import { RoleId } from './features/users/enums/role.enum';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('./features/auth/pages/auth-callback-page/auth-callback-page').then(
        (m) => m.AuthCallbackPage,
      ),
  },
  {
    matcher: langMatcher,
    children: [
      {
        path: 'forbidden',
        providers: [provideFeatureTranslations(['auth'])],
        resolve: {
          i18n: featureTranslationResolver,
        },
        loadComponent: () =>
          import('./features/auth/pages/forbidden-page/forbidden-page').then(
            (m) => m.ForbiddenPage,
          ),
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: '',
        component: FooterOnlyLayout,
        children: [
          {
            path: 'register-attendance',
            loadChildren: () =>
              import('./features/registerAttendance/register-attendance.routes').then(
                (m) => m.REGISTER_ATTENDANCE_ROUTES,
              ),
          },
          {
            path: 'login',
            canActivate: [LoginGuard],
            providers: [provideFeatureTranslations(['auth'])],
            resolve: {
              i18n: featureTranslationResolver,
            },
            loadComponent: () =>
              import('./features/auth/pages/login-page/login-page').then((m) => m.LoginPage),
          },
        ],
      },
      {
        path: '',
        component: MainLayout,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },

          {
            path: 'home',
            loadChildren: () => import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
          },
          {
            path: 'course-planning',
            loadChildren: () =>
              import('./features/course-planning/course-planning.routes').then(
                (m) => m.COURSE_PLANNING_ROUTES,
              ),
          },
          {
            path: 'attendance',
            loadChildren: () =>
              import('./features/attendance/attendance.routes').then((m) => m.ATTENDANCE_ROUTES),
          },
          {
            path: 'calendar',
            loadChildren: () =>
              import('./features/calendar/calendar.routes').then((m) => m.CALENDAR_ROUTES),
          },
          {
            path: 'catalogs',
            canActivate: [roleGuard],
            data: {
              roles: [RoleId.Admin, RoleId.NationalOffice],
            },
            loadChildren: () =>
              import('./features/catalogs/catalogs-routes').then((m) => m.CATALOGS_ROUTES),
          },
          {
            path: 'events',
            canActivate: [roleGuard],
            data: {
              roles: [RoleId.Admin],
            },
            loadChildren: () =>
              import('./features/events/events.routes').then((m) => m.EVENTS_ROUTES),
          },
          {
            path: 'qrs',
            loadChildren: () => import('./features/qrs/qrs.routes').then((m) => m.QRS_ROUTES),
          },

          {
            path: 'users',
            canActivate: [roleGuard],
            data: {
              roles: [RoleId.Admin, RoleId.NationalOffice],
            },
            loadChildren: () => import('./features/users/user.routes').then((m) => m.USERS_ROUTES),
          },
          {
            path: '**',
            redirectTo: 'home',
          },
        ],
      },
    ],
  },

  // fallback no lang
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'en-US',
  },

  // fallback invalid routes
  {
    path: '**',
    redirectTo: 'en-US',
  },
];
